import { GlobalStyles } from '@mui/material';
import { SnackbarProvider } from 'notistack';

import {
  ErrorSnackbar,
  InfoSnackbar,
  SuccessSnackbar,
  WarningSnackbar,
} from './variants';

interface SnackbarsProviderProps {
  children: React.ReactNode;
}

const SNACKBAR_CONTAINER_CLASS = 'lemon-snackbar-container';

const SnackbarsProvider = ({ children }: SnackbarsProviderProps) => {
  return (
    <>
      <GlobalStyles
        styles={{
          [`.${SNACKBAR_CONTAINER_CLASS}`]: {
            zIndex: '10000000 !important',
          },
        }}
      />
      <SnackbarProvider
        maxSnack={5}
        classes={{ containerRoot: SNACKBAR_CONTAINER_CLASS }}
        Components={{
          success: SuccessSnackbar,
          info: InfoSnackbar,
          error: ErrorSnackbar,
          warning: WarningSnackbar,
        }}
      >
        {children}
      </SnackbarProvider>
    </>
  );
};

export default SnackbarsProvider;
